import { Text, TextProps } from "@mantine/core";

/** Default tint matches nav; callers (e.g. footer) override with `c="white"`. */
export default function LogoText({ c = "lightblue", ...rest }: TextProps) {
  return (
    <Text size={"1.6rem"} fw={450} lh={1.3} c={c} {...rest}>
      Tiber Tutor
    </Text>
  );
}
